import { render, staticRenderFns } from "./index-dev.vue?vue&type=template&id=74e9f59a&scoped=true"
import script from "./index-dev.vue?vue&type=script&lang=js"
export * from "./index-dev.vue?vue&type=script&lang=js"
import style0 from "./index-dev.vue?vue&type=style&index=0&id=74e9f59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e9f59a",
  null
  
)

export default component.exports